import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'
import { SansText } from '@velasca/ui/sans-text'

export const Background = styled.li`
  background: ${({ theme }) => theme.colors.modalBackground};
  width: 100%;
`

export const Card = styled.div`
  padding: 0 2.2rem;
  display: flex;
  gap: 1.8rem;
`

export const ImageWrapper = styled.div`
  height: 16vh;
  min-height: 9rem;
  max-height: 15rem;
  aspect-ratio: 4/5;
`

export const LoadingImage = styled(Skeleton)`
  height: 100%;
  display: block;
`

export const LoadingButton = styled.div`
  padding: 1.1rem 2.2rem;
  display: flex;
  align-items: center;
`

export const ProductImage = styled(ResponsiveImage)`
  height: 100%;
  object-fit: cover;
`

export const Details = styled.div`
  display: flex;
  gap: 0.4rem;
  flex-direction: column;
  justify-content: center;
`

export const Separator = styled.hr`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin: 0.5rem 0 0 0;
`

export const Button = styled.button`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 1rem 2.4rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  border: none;
  background: ${({ theme }) => theme.colors.modalBackground};

  &:disabled {
    background: ${({ theme }) => theme.colors.disabled};
    pointer-events: none;

    ${SansText} {
      color: ${({ theme }) => theme.colors.text.light};
    }
  }

  &:active {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`
